import { z } from 'zod';

/**
 * The validation schema is used to track and validate user input for document types
 * The document type will be a selection that determine the document title
 * We don't save document type into the database, and it is only used for selection
 */

export const DocumentTypeValidationSchema = z.union([
  z.literal('INSURANCE_ID_CARD'),
  z.literal('INSURANCE_BINDER'),
  z.literal('TRADE_REGISTRATION'),
  z.literal('BANK_STATEMENTS'),
  z.literal('UTILITY_BILLS'),
  z.literal('PROOF_OF_INCOME'),
  z.literal('CONTRACT'),
  z.literal('OTHER')
]);

export type DocumentType = z.infer<typeof DocumentTypeValidationSchema>;

export type DocumentTypeOption = {
  value: DocumentType;
  label: string;
  documentTitle: string;
};
